/** 登录注册 */
export const login = [
  {
    name: 'loginByMobilePwd', // 密码登录
    isMock: false,
  },
]
